export default __webpack_public_path__ + "static/media/lms_domain.1987f18d.png";